<template>
  <div class="gallery-detail">
    <div class="nav-bar">
      <div class="left">
        <img class="logo" src="@/assets/jhk_logo.png" />
        <h3 class="nav-bar-title">
          加画框 <span class="divider-line"></span> <span class="subtitle">为画加框，为艺增色</span>
        </h3>
      </div>
      <wx-open-launch-app
        v-if="canWxOpen"
        id="launch-nav-btn"
        :appid="appid"
        class="open-app-btn"
        @launch="wxLaunchApp"
        @error="wxLaunchAppError"
      >
      </wx-open-launch-app>
      <button v-else class="open-app-btn" @click="openApp(true)">打开APP</button>
    </div>
    <div class="nav-bar-placeholder"></div>
    <div class="content-view">
      <div class="work" :style="{ 'aspect-ratio': isFullScreen ? '3/4' : '1' }">
        <swiper :modules="modules" :pagination="true">
          <swiper-slide v-for="item in detail.banners" :key="item"
            ><img class="slide-img" :src="item"
          /></swiper-slide>
        </swiper>
      </div>
      <div class="work-info">
        <div class="work-info-left">
          <span class="title" v-html="firstLineTitle"></span>
          <span class="title" v-if="secondLineTitleLine !== ''" v-html="secondLineTitleLine"></span>
        </div>
        <span class="usage-amount"><span class="divider-line"></span>{{ formatUseNum }}</span>
      </div>
    </div>
    <div class="spacer"></div>
    <!--根据微信开放标签文档，定位元素需要加到父级，不能在开放标签中使用-->
    <wx-open-launch-app
      id="launch-btn"
      v-if="canWxOpen"
      :appid="appid"
      :extinfo="wxExtinfo"
      class="nav-app-btn"
      @launch="wxLaunchApp"
      @error="wxLaunchAppError"
    >
    </wx-open-launch-app>
    <button v-else class="nav-app-btn" @click="openApp(false)">打开加画框APP，一键加同款</button>
  </div>
</template>

<script>
import {
  ANDROID_APPID,
  ANDROID_DOWNLOAD_URL,
  initWxWebConfig,
  iOS_APPID,
  iOS_DOWNLOAD_URL,
  onWxReady
} from '@/config/wx-config'
import { checkIsWeixin, checkPlatform, pwToPx, throttle } from '@/utils/utils'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination } from 'swiper/modules'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'
import { findGalleryDetail } from '@/services/api/galleryApi'
import { getJsApiTicket } from '@/services/api/wxApi'
import { countLandingPageDayLog } from '@/services/api/statAPi'

export default {
  name: 'GalleryDetail',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      // 模版id
      id: null,
      // 模版数据
      detail: {},
      appid: ANDROID_APPID,
      // 唤起APP计时器
      timer: null,
      isFullScreen: false,
      downloadUrl: '',
      isiOS: false,
      isAndroid: false,
      isWeixin: false,
      /// js-sdk是否都初始化好
      isReady: false,
      // 传递给app的数据
      wxExtinfo: '{}',
      formatUseNum: ''
    }
  },
  created() {
    this.getPlatform()
    this.initData()
    /// 埋点-落地页访问
    countLandingPageDayLog({ event: 0 })
    if (this.isiOS) {
      this.downloadUrl = iOS_DOWNLOAD_URL
      this.appid = iOS_APPID
    } else {
      this.downloadUrl = ANDROID_DOWNLOAD_URL
    }
  },
  mounted() {
    this.judgeFullScreen()
    window.addEventListener('resize', this.resizeListener)
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.log('微信开放标签错误')
      alert('微信版本过低，请升级微信或使用浏览器打开')
      console.error(e.detail.errMsg) // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    })
    /// 监听页面隐藏
    document.addEventListener('visibilitychange', () => {
      clearTimeout(this.timer)
    })
    this.renderBtnDom()
  },
  unmounted() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    initData() {
      const templateId = this.$route.params.id
      this.id = templateId
      this.wxExtinfo = `{"detail": "${templateId}"}`
      findGalleryDetail({ templateId }).then((res) => {
        this.detail = res
        /// 使用次数小于10，显示最新模板
        try {
          this.formatUseNum =
            parseInt(this.detail.formatUseNum) >= 10
              ? `${this.detail.formatUseNum}次使用`
              : '最新模板'
        } catch (e) {
          this.formatUseNum = `${this.detail.formatUseNum}次使用`
        }
        this.initWxCapability(res)
      })
    },
    getPlatform() {
      this.isiOS = checkPlatform().toLowerCase() === 'ios'
      this.isAndroid = checkPlatform().toLowerCase() === 'android'
      this.isWeixin = checkIsWeixin()
    },
    /// @param: 接受模版信息的参数，用来设置分享时的标题信息
    /// 初始化微信网页能力
    initWxCapability(params) {
      const url = window.location.href.split('#')[0]
      getJsApiTicket({ url }).then((res) => {
        initWxWebConfig(res)
        onWxReady(params.title, url, params.banners[0])
          .then((isInit) => {
            console.log('是否初始化完成', isInit)
            this.isReady = isInit
          })
          .catch((err) => {
            console.log('初始化失败,')
            this.isReady = false
          })
          .finally(() => {
            console.log('isInWeixin', this.isWeixin)
            console.log('isiOS', this.isiOS)
          })
      })
    },
    /// 监听视口变化，控制banner比例
    resizeListener: throttle(function () {
      this.judgeFullScreen()
    }, 20),
    judgeFullScreen() {
      const rate = window.screen.height / window.screen.width
      let limit = window.screen.height === window.screen.availHeight ? 1.8 : 1.65
      this.isFullScreen = rate > limit
    },
    /// 兼容普通浏览器--------打开app
    /// @noParams：boolean,是否要传参数;如果不传参数只是打开app，不进入模板详情页
    openApp(noParams) {
      try {
        let url_schema = noParams
          ? 'jiahk://com.jiahk.jiahuakuang'
          : 'jiahk://com.jiahk.jiahuakuang?detail=' + this.id
        if (this.isiOS) {
          /// 通用链接唤起APP
          url_schema = noParams
            ? 'https://www.jiahk.cn/app/'
            : 'https://www.jiahk.cn/app?detail=' + this.id
        }
        /// 本地存储用户试图打开ios客户端的行为
        localStorage.setItem('attempt_to_jiahk_ios', 'true')
        /// 如果是ios则会打开通用链接
        window.location.href = url_schema
        if (!this.isiOS) {
          this.timer = setTimeout(() => {
            countLandingPageDayLog({ event: 1 }).finally(() => {
              /// 如果没有打开APP（未安装时没有反应）
              window.location.href = this.downloadUrl
            })
          }, 3000)
        }
      } catch (e) {
        countLandingPageDayLog({ event: 1 }).finally(() => {
          /// 打开app失败
          window.location.href = this.downloadUrl
        })
      }
    },
    /// 适用于微信浏览器中打开app失败场景
    wxLaunchAppError(e) {
      console.log('打开失败', e)
      /// android 直接展示应用宝，埋点-app下载入口展示
      countLandingPageDayLog({ event: 1 }).finally(() => {
        /// 如果是ios则会跳转到app store
        window.location.href = this.downloadUrl
      })
    },
    wxLaunchApp(e) {
      console.log('唤起成功')
    },
    renderBtnDom() {
      if (this.isWeixin && this.isAndroid) {
        const navBtnEl = document.getElementById('launch-nav-btn')
        const launchBtnEl = document.getElementById('launch-btn')
        /// 高度和字体大小均是对应元素标签px转换后的vw大小(借助post-css-to-viewport插件)，可在开发中工具中定位到查看；
        // 由于微信开放标签中的样式是隔离的，且不支持vw、rem等适配，需要自行转换后并使用px来表示，所以这个部份比较繁琐
        const navBtnHeight = pwToPx(7.777778) + 'px'
        const launchBtnHeight = pwToPx(13.333333) + 'px'
        const navBtnFontSize = pwToPx(3.333333) + 'px'
        const launchBtnFontSize = pwToPx(3.888889) + 'px'
        navBtnEl.innerHTML =
          `<script  type="text/wxtag-template">
        <style>
          .btn { width: 100%; height: ${navBtnHeight};color: white; display:flex; justify-content:
          center;align-items: center;-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing:
          grayscale;font-size: ${navBtnFontSize};
        </style>
        <div class="btn">打开APP</div></` + 'script>'
        launchBtnEl.innerHTML =
          `<script type="text/wxtag-template">
      <style>
        .btn { width: 100%; height: ${launchBtnHeight}; color: white; display:flex; justify-content:
        center;align-items: center;-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing:
        grayscale;font-size: ${launchBtnFontSize};
      </style>
      <div class="btn">打开加画框APP，一键加同款</div></` + 'script>'
      }
    }
  },
  computed: {
    // 支持36个文字显示。
    // 2)单行最大显示字数为18个字。
    // 3）超出文字部分使用省略号表示。
    firstLineTitle() {
      if (!this.detail.title) return ''
      return this.detail.title.substring(0, 18)
    },
    secondLineTitleLine() {
      if (!this.detail.title || this.detail.title.length <= 18) return ''
      let str = this.detail.title
      if (str.length > 18) {
        str = str.slice(18, 36)
      }
      if (this.detail.title.length > 36) {
        str += '...'
      }
      return str
    },
    canWxOpen() {
      /// 只有Android 微信上才使用开放标签，
      return this.isAndroid && this.isWeixin
    }
  },
  setup() {
    return {
      modules: [Pagination]
    }
  }
}
</script>

<style lang="less">
.gallery-detail {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .spacer {
    flex: 1;
  }
}
.nav-bar {
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: #fff;
  z-index: 999;
  & > .left {
    display: flex;
    .logo {
      width: 32px;
      height: 32px;
    }

    .nav-bar-title {
      display: flex;
      justify-items: center;
      align-items: center;
      margin: 0 0 0 8px;
      font-size: 14px;
      color: #3b3b3b;
      font-weight: 500;
    }

    .subtitle {
      font-size: 12px;
      color: #767676;
      font-weight: normal;
    }
  }
  /// 这个样式是针对非微信网页环境下的，即普通浏览器
  .open-app-btn {
    width: 72px;
    height: 28px;
    background-color: var(--primary-color--light);
    font-size: 12px;
    color: white;
    border-radius: 3px;
    border: none;
    outline: none;
  }
}

.nav-bar-placeholder {
  height: 56px;
}

.divider-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #3b3b3b;
  margin: 0 8px;
}

/// 这个样式是针对非微信网页环境下的，即普通浏览器
.nav-app-btn {
  flex-shrink: 0;
  width: calc(100% - 44px);
  height: 48px;
  margin: 18px 22px 25px 22px;
  color: #fff;
  font-size: 14px;
  background-color: var(--primary-color);
  border-radius: 6px;
  border: none;
  outline: none;
  z-index: 999;
}

.work {
  background-color: #f8f8f8;
}

.work-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 14px 20px 16px;
  /* apply-without-convert */
  border-bottom: 1px solid #eaeaea;
  .work-info-left {
    .title {
      display: block;
      text-overflow: clip;
      overflow: hidden;
      white-space: nowrap;
      font-size: 14px;
      color: #222222;
    }
  }

  .usage-amount {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 12px;
    color: #979797;
    .divider-line {
      margin-left: 8px;
      background-color: #979797;
    }
  }
}

/// 轮播样式
.swiper {
  width: 100%;
  height: 100%;
}
.slide-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.swiper-pagination-bullet {
  width: 7px;
  height: 7px;
  background: #d8d8d8;
  opacity: 1;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.swiper-pagination-bullet-active {
  background: white;
}
</style>
